import {
  IsArray,
  IsBoolean,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  IsUUID,
} from 'class-validator';

export class GetCatalogAttributesDto {
  @IsUUID()
  @IsString()
  @IsNotEmpty()
  eventId: string;

  @IsUUID()
  @IsString()
  @IsNotEmpty()
  attributeId: string;

  @IsNumber()
  @IsOptional()
  limit?: number;

  @IsNumber()
  @IsOptional()
  offset?: number;

  @IsString()
  @IsOptional()
  query?: string;

  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsOptional()
  ids?: string[];

  @IsBoolean()
  @IsOptional()
  hierarchic_view?: boolean;

  @IsUUID()
  @IsString()
  @IsOptional()
  hierarchic_start_item_id?: string;

  @IsString({ each: true })
  @IsArray()
  @IsOptional()
  values?: string[];
}
